import { createSlice } from "@reduxjs/toolkit"
import {
  IPatientReportResponse,
  IPatientCaseReportResponse,
} from "@/modules/Patient/Overview/components/patientReportTables/patient-report.types"
import { fetchPatientReport, fetchPatientCaseReport } from "./patientReportThunkApi"

interface IPatientReportState {
  patientReport: IPatientReportResponse | null
  loading: "idle" | "pending" | "succeeded" | "failed"
  patientCaseReport: IPatientCaseReportResponse | null
  caseReportLoading: "idle" | "pending" | "succeeded" | "failed"
}

const initialState: IPatientReportState = {
  patientReport: null,
  loading: "idle",
  patientCaseReport: null,
  caseReportLoading: "idle",
}

export const patientReportSlice = createSlice({
  name: "patientReport",
  initialState,
  reducers: {
    resetPatientReport(state) {
      state.patientReport = null
      state.loading = "idle"
    },
    resetPatientCaseReport(state) {
      state.patientCaseReport = null
      state.caseReportLoading = "idle"
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchPatientReport.pending, (state) => {
      state.loading = "pending"
    })
    builder.addCase(fetchPatientReport.fulfilled, (state, action) => {
      state.patientReport = action.payload
      state.loading = "succeeded"
    })
    builder.addCase(fetchPatientReport.rejected, (state) => {
      state.patientReport = null
      state.loading = "failed"
    })
    builder.addCase(fetchPatientCaseReport.pending, (state) => {
      state.caseReportLoading = "pending"
    })
    builder.addCase(fetchPatientCaseReport.fulfilled, (state, action) => {
      state.patientCaseReport = action.payload
      state.caseReportLoading = "succeeded"
    })
    builder.addCase(fetchPatientCaseReport.rejected, (state) => {
      state.patientCaseReport = null
      state.caseReportLoading = "failed"
    })
  },
})

export const { resetPatientReport, resetPatientCaseReport } = patientReportSlice.actions
